import { useRef } from 'react';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import ShortHeaderWithBackBtnNameOfGod from 'components/root/partials/header/ShortHeaderWithBackBtnNameOfGod';
import formStyles from 'styles/css/FormStyles.module.scss';
import ruleStyles from 'styles/css/RuleStyles.module.scss';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataSurguryConsultationPage } from "reduxx/actions/pages/surguryConsultation";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import apiRequest from 'utils/apiRequest';
import { BASE_SITE, SURGURY_CONSULTATION } from 'apis'; 
import { handleSetBackdropLoading, handleChangeBackdropLoadingData } from 'reduxx/actions/loaders';
import imageCompression from 'browser-image-compression';

const SurgeryConsultation = () => {

    const dispatch = useDispatch();

    const { inputFullname, inputMobile, inputEmail, inputComment, attachFile, filePreview, onlyForm } = useSelector(state => state.surguryConsultation);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        
        if(name === 'inputComment' && value.length > 700)
            return;

        if(name === 'inputMobile')
            dispatch(handleChangeDataSurguryConsultationPage(name, changeNumberPersianAndArabic(value)));
        else 
            dispatch(handleChangeDataSurguryConsultationPage(name, value));
    };

    const changeNumberPersianAndArabic = (str) => {
        let
            persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if (typeof str === 'string') {
            for (let i = 0; i < 10; i++) {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

    // const handleSubmitForm = (event) => {
    //     event.preventDefault();

    //     if(inputFullname.trim().length < 3) {
    //         dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
    //     }
    //     else if(inputMobile.trim().length === 0)
    //         dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
    //     else if(inputMobile.trim().length !== 11)
    //         dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
    //     else if(inputComment.trim().length === 0)
    //         dispatch(handleSetOpenCustomSnackbar(true, {message: 'متن نظر را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
    //     else {
    //         if(! isBackdropLoading) {
    //             apiRequest({
    //                 dispatch,
    //                 endpoint: SURGURY_CONSULTATION,
    //                 method: 'post',
    //                 data: { mobile: inputMobile, fullname: inputFullname, email: inputEmail, comment: inputComment },
    //                 token: null,
    //                 successMessage: 'درخواست شما با موفقیت ثبت شد',
    //                 onSuccess: (res) => {
    //                     dispatch(handleChangeDataSurguryConsultationPage('inputMobile', ''));
    //                     dispatch(handleChangeDataSurguryConsultationPage('inputFullname', ''));
    //                     dispatch(handleChangeDataSurguryConsultationPage('inputEmail', ''));
    //                     dispatch(handleChangeDataSurguryConsultationPage('inputComment', ''));
    //                     // navigate(`verify`);
    //                 },
    //             });
    //         }

    //     }
    // };


    const handleSubmitForm = async () => {
        if(isBackdropLoading) return;

        if(inputFullname.trim().length < 3) {
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'نام و نام خانوادگی خود را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        }
        else if(inputMobile.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputMobile.trim().length !== 11)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'موبایل یا تلفن ثابت باید 11 رقم باشد  ', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else if(inputComment.trim().length === 0)
            dispatch(handleSetOpenCustomSnackbar(true, {message: 'متن نظر را وارد کنید', severity: 'error', vertical: 'top', horizontal: 'right'}));
        else {
            const formData = new FormData();
            formData.append('mobile', inputMobile);
            formData.append('fullname', inputFullname);
            formData.append('email', inputEmail);
            formData.append('comment', inputComment);

            if (attachFile) {
                formData.append('file', attachFile);
            }

            try {
                dispatch(handleSetBackdropLoading(true));

                const response = await fetch(BASE_SITE + SURGURY_CONSULTATION, {
                    method: 'POST',
                    body: formData,
                });

                const result = await response.json();

                if(response.ok) {
                    if(result.status === 'ok') {
                        dispatch(handleChangeDataSurguryConsultationPage('inputMobile', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputFullname', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputEmail', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('inputComment', ''));
                        dispatch(handleChangeDataSurguryConsultationPage('attachFile', false));
                        dispatch(handleChangeDataSurguryConsultationPage('filePreview', null));
                        if (fileInputRef.current) {
                            fileInputRef.current.value = '';
                        }

                        dispatch(handleSetOpenCustomSnackbar(true, {message: 'درخواست شما با موفقیت ثبت شد', severity: 'success', vertical: 'top', horizontal: 'center'}));  
                        // navigate(`verify`);
                    }
                    else if(result.status === 'error') {
                        dispatch(handleSetOpenCustomSnackbar(true, {message: result.message, severity: 'error', vertical: 'top', horizontal: 'center'}));  
                    }
                }
                else {
                    dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                }
                dispatch(handleSetBackdropLoading(false));
            } catch (err) {
                dispatch(handleSetOpenCustomSnackbar(true, {message: 'خطا در اتصال به سرور.لطفا دقایقی دیگر تلاش کنید', severity: 'error', vertical: 'top', horizontal: 'center'}));  
                dispatch(handleSetBackdropLoading(false));
            } finally {
                dispatch(handleSetBackdropLoading(false));
            }
        }
  
    };


    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };


    const fileInputRef = useRef(null);
    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        dispatch(handleChangeBackdropLoadingData(true, 'در حال آماده‌سازی تصویر...'));

        try {
            let processed = file;

            if (file.type.startsWith('image/')) {
                // ⚡ FAST resize first (Android safe)
                processed = await resizeImageFast(file, 800);

                // 🔽 optional compress
                processed = await compressLight(processed);
            }

            dispatch(handleChangeDataSurguryConsultationPage('attachFile', processed));
            dispatch(handleChangeDataSurguryConsultationPage(
                'filePreview',
                URL.createObjectURL(processed)
            ));

        } catch (e) {
            console.error(e);
            dispatch(handleChangeDataSurguryConsultationPage('attachFile', file));
        } finally {
            dispatch(handleChangeBackdropLoadingData(false, ''));
        }
    };


    const resizeImageFast = (file, maxSize = 800) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const url = URL.createObjectURL(file);

            img.onload = () => {
                let { width, height } = img;

                if (width > height && width > maxSize) {
                    height = Math.round(height * (maxSize / width));
                    width = maxSize;
                } else if (height > maxSize) {
                    width = Math.round(width * (maxSize / height));
                    height = maxSize;
                }

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext('2d', { alpha: false });
                ctx.drawImage(img, 0, 0, width, height);

                canvas.toBlob(
                    blob => {
                        URL.revokeObjectURL(url);
                        if (!blob) return reject();
                        resolve(new File([blob], file.name, { type: 'image/jpeg' }));
                    },
                    'image/jpeg',
                    0.75
                );
            };

            img.onerror = reject;
            img.src = url;
        });
    };

    const compressLight = async (file) => {
        if (file.size < 200 * 1024) return file;

        return await imageCompression(file, {
            maxSizeMB: 0.2,
            useWebWorker: true,
            initialQuality: 0.7,
        });
    };


    return (
        
        <div className={sharedStyles.container} id={ruleStyles['rules-page']}>

            <div className={[sharedStyles['container-padding'], sharedStyles['pb-[64px]']].join(' ')}>
                <ShortHeaderWithBackBtnNameOfGod />
                

                <p className={[formStyles['text-center'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                    دکتر بیست با کمال افتخار، خدمات جامع پزشکی و مشاوره تخصصی را به توریست‌های عزیز ایرانی (در شیراز  و سایر استان‌ها) و گردشگران سلامت از سایر کشورها ارائه می‌دهد.
                </p>


                
                <div className={[formStyles.title, formStyles['text-center'], formStyles['!text-primary'], sharedStyles['mt-[64px]']].join(' ')}>
                    فرم درخواست مشاوره اعمال جراحی
                </div>

                <input type="text" name="inputFullname" value={inputFullname} onChange={handleChangeInputs} className={[formStyles.input, sharedStyles['mt-[16px]']].join(' ')} placeholder="نام و نام خانوادگی" />
                <input type="email" name="inputEmail" value={inputEmail} onChange={handleChangeInputs} className={formStyles.input} placeholder="ایمیل (اختیاری)" />
                <input type="tel" name="inputMobile" value={inputMobile} onChange={handleChangeInputs} className={formStyles.input} placeholder="شماره موبایل" style={{direction: 'rtl'}} />
                <textarea rows={5} name="inputComment" value={inputComment} onChange={handleChangeInputs} className={formStyles.input} placeholder="شرح مختصری از درخواست خود برای پزشک بنویسید" style={{marginBottom: '0'}} />
                <span>{toPersianDigits(inputComment.length)}/{toPersianDigits(700)}</span>
                <div className={[sharedStyles.flex, sharedStyles.justifyBetween, sharedStyles.itemsCenter].join(' ')} style={{marginTop: '1rem'}}>
                    <span onClick={handleUploadClick} className={[sharedStyles['text-primary'], sharedStyles['cursor-pointer']].join(' ')}>
                        بارگذاری مدارک پزشکی
                    </span>
                    { attachFile &&
                        <span>{attachFile.name}</span>
                    }
                </div>
                <input
                    type="file"
                    accept="image/*,.pdf"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                />
                <button onClick={handleSubmitForm} className={[formStyles.button, sharedStyles['!mt-[24px]']].join(' ')}>ارسال</button>



                { !onlyForm &&
                    <>
                        <p className={[ruleStyles['text-justify'], sharedStyles['mt-[64px]']].join(' ')}>
                            این خدمات شامل تمامی رشته‌های پزشکی و جراحی تخصصی و فوق‌تخصصی در بیمارستان‌ها و مراکز درمانی معتبر ایران (دارای شاخص IPD) است.
                        </p>

                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۱- پیوند اعضا(Organ Transplantation)
                        </p>
                        <ul>
                            <li>پیوند کبد</li>
                            <li>پیوند قرنیه</li>
                            <li>پیوند کلیه</li>
                            <li>پیوند قلب و ریه</li>
                            <li>پیوند مغز استخوان</li>
                            <li>پیوند پانکراس (لوزالمعده)</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۲- چشم‌پزشکی (Ophthalmology)
                        </p>
                        <ul>
                            <li>لیزیک (LASIK) و PRK</li>
                            <li>پیوند قرنیه و کراتوپلاستی</li>
                            <li>جراحی آب مروارید  (Cataract)</li>
                            <li>جراحی آب سیاه  (Glaucoma)</li>
                            <li>اپتومتری و تصحیح عیوب انکساری چشم</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۳- دندان‌پزشکی عمومی و تخصصی 
                            <br />
                            (General & Specialized Dentistry)
                        </p>
                        ارائه‌ی کلیه‌ی خدمات دندان‌پزشکی با بهره‌گیری از متخصصان مجرب در رشته‌های مختلف، شامل:
                        <ul>
                            <li>
                                خدمات عمومی:
                                <ul>
                                    <li>جرم‌گیری و بروساژ</li>
                                    <li>پر کردن و ترمیم دندان</li>
                                    <li>درمان ریشه  (Root Canal Therapy)</li>
                                    <li>کشیدن و جراحی دندان‌های نهفته</li>
                                </ul>
                            </li>
                            <li>
                                خدمات تخصصی:
                                <ul>
                                    <li>ایمپلنتولوژی (کاشت دندان): کاشت ایمپلنت و بازسازی لبخند</li>
                                    <li>ارتودنسی: صاف و منظم‌سازی دندان‌ها با براکت یا الاینر شفاف</li>
                                    <li>درمان ریشه  (Root Canal Therapy)</li>
                                    <li>پروتز و زیبایی: پروتز و زیبایی:</li>
                                </ul>
                            </li>
                            <li>
                                طراحی لبخند، لمینت، روکش، بلیچینگ
                                <ul>
                                    <li>دندان‌پزشکی کودکان: درمان دندان‌های شیری و مراقبت دهان کودکان</li>
                                    <li>درمان لثه:  (Periodontics)جراحی و درمان بیماری‌های لثه و ایمپلنت</li>
                                    <li>جراحی فک و صورت: جراحی دندان‌های نهفته، اصلاح فک و بازسازی استخوان</li>
                                    <li>رادیولوژی و پاتولوژی دهان: تشخیص ضایعات دهانی با تصویر‌برداری تخصصی و بررسی بافت‌شناسی</li>
                                </ul>
                            </li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۴- پوست، مو و زیبایی 
                            <br />
                            (Cosmetic & Dermatology)
                        </p>
                        <ul>
                            <li>کاشت مو، ابرو و مژه</li>
                            <li>لیزر و ریمو تاتو، خال و زگیل</li>
                            <li>جوان‌سازی پوست، تزریق بوتاکس و فیلر</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۵- قلب و عروق  (Cardiology)
                        </p>
                        <ul>
                            <li>اکوکاردیوگرافی</li>
                            <li>بالون و استنت‌گذاری  (Angioplasty)</li>
                            <li>رفع تنگی عروق کرونر با روش‌های های‌تک</li>
                            <li>جراحی قلب باز  (CABG)</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۶- گوش، حلق و بینی  (ENT)
                        </p>
                        <ul>
                            <li>جراحی زیبایی بینی</li>
                            <li>اصلاح انحراف تیغه بینی</li>
                            <li>برداشتن پولیپ بینی</li>
                            <li>جراحی لوزه  (Tonsillectomy)</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۷- ارتوپدی  (Orthopedics)
                        </p>
                        <ul>
                            <li>تعویض مفصل زانو و لگن</li>
                            <li>آرتروسکوپی</li>
                            <li>جراحی دیسک کمر و گردن</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۸- جراحی مغز و اعصاب  (Neurosurgery)
                        </p>
                        <ul>
                            <li>جراحی تنگی کانال نخاعی</li>
                            <li>جراحی تومورهای مغزی و نخاعی</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۹- اورولوژی  (Urology)
                        </p>
                        <ul>
                            <li>درمان سنگ کلیه و مثانه</li>
                            <li>درمان بزرگی پروستات  (BPH)</li>
                            <li>جراحی تومورهای دستگاه ادراری</li>
                        </ul>


                        <p className={[ruleStyles['text-justify'], ruleStyles['font-weight-800'], formStyles['!text-primary']].join(' ')}>
                            ۱۰- بیماری‌های داخلی  (Internal Medicine)
                        </p>
                        <ul>
                            <li>قلب، ریه، گوارش، غدد، مغز و اعصاب، و روماتولوژی</li>
                        </ul>
                    </>
                }



                


            </div>
                
        </div>

    );
}

export default SurgeryConsultation;